interface QrEyeProps {
  /** Rendered px size (square). Inline default ~20; the Procesando loader sizes it up. */
  size?: number
  /** Color comes from `currentColor` — call sites set it (brand default `text-rosa`, per KTD2). */
  className?: string
}

/**
 * The QR-eye: the corner finder pattern of a QR code (a ring around a solid
 * eye) — Súbela's recurring signature mark (liga chip, header, section bullets,
 * the Procesando loader). Purely decorative, so `aria-hidden`; it never carries
 * meaning a screen reader would need.
 */
export default function QrEye({ size = 20, className }: QrEyeProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <rect
        x="2.5"
        y="2.5"
        width="19"
        height="19"
        rx="5.5"
        stroke="currentColor"
        strokeWidth="3"
      />
      <rect x="8.5" y="8.5" width="7" height="7" rx="2" fill="currentColor" />
    </svg>
  )
}
